import { WarningAmberOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

const CameraTimeout = ({ onRetry }: { onRetry: () => void }) => (
  <Box
    className="tw-flex tw-h-full tw-min-h-[240px] tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-bg-gtr-surface-muted tw-p-6 tw-text-center tw-text-gtr-text"
    sx={{
      bgcolor: "#f8fafc",
      borderRadius: 3,
      width: "100%",
      minHeight: 240,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 1.5,
    }}
  >
    <Box className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-amber-100 tw-text-amber-700">
      <WarningAmberOutlined />
    </Box>
    <Typography sx={{ color: "#334155", fontFamily: "Prometo", fontWeight: 700, maxWidth: 460 }}>
      Não foi possível conectar à câmera, verifique a conexão e se a câmera está ativa.
    </Typography>
  </Box>
);


export default CameraTimeout;
